import useGeneralStore from "@/store/General/useGeneralStore";
import { parseJsonBody } from "@/lib/general.utils";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { Button } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";

const Footer = () => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const home = useGeneralStore(state => state.HomeComponent);
  const registration = parseJsonBody(home?.jsonBody).foundation?.registration;
  const isServicePage = new Set(["/services/[serviceTitle]"]).has(
    router.pathname,
  );

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`w-full bg-white relative mt-[6rem] ${
        isServicePage && "hidden md:block"
      }`}
    >
      {/* Top White Section with Logo */}
      <div className="absolute top-[-3.8rem] md:top-[-5rem] left-1/2 -translate-x-1/2 z-10 mt-6">
        <div className="bg-white aspect-square w-[8rem] md:w-[10rem] rounded-lg with-box-shadow p-[0.3rem] flex items-center justify-center">
          <Image
            src="/icons/long-logo.png"
            className=" aspect-square object-contain"
            width={1000}
            height={1000}
            alt="logo"
          />
        </div>
      </div>

      {/* Middle Dark Blue Section */}
      <div
        style={{ direction: "rtl" }}
        className="w-full bg-primary pt-[7rem] md:pt-[7.5rem] pb-[2rem] px-[2rem] flex flex-col md:flex-row items-center justify-between gap-[2rem]"
      >
        {/* Volunteer Button - Left */}
        <Button
          variant="contained"
          className="bg-white text-primary rounded-full px-[2rem] py-[0.75rem] font-bold text-[1.1rem] hover:bg-white/90 normal-case"
        >
          {t("header.volunteer")}
        </Button>

        {/* Navigation Links - Center */}
        <div className="flex flex-wrap items-center justify-center gap-[2rem] text-white text-[1rem]">
          <Link
            href="/about"
            className="hover:text-secondary transition-colors whitespace-nowrap"
          >
            {t("header.about")}
          </Link>
          <Link
            href="/terms-and-conditions"
            className="hover:text-secondary transition-colors whitespace-nowrap"
          >
            {t("header.terms")}
          </Link>
          <Link
            href="/faqs"
            className="hover:text-secondary transition-colors whitespace-nowrap"
          >
            {t("header.questions")}
          </Link>
        </div>

        {/* Registration Number - Right */}
        <div className="text-white text-[0.9rem] whitespace-nowrap">
          {registration}
        </div>
      </div>

      {/* Bottom Lighter Blue Section */}
      <div
        style={{ direction: "rtl" }}
        className="w-full bg-secondary py-[1.5rem] px-[2rem] flex items-center justify-between"
      >
        {/* Scroll to Top Button - Left */}
        <button
          onClick={scrollToTop}
          className="bg-white/30 hover:bg-white/40 rounded-lg w-[3rem] h-[3rem] flex items-center justify-center transition-colors"
          aria-label="Scroll to top"
        >
          <KeyboardArrowUp className="text-white text-[1.5rem]" />
        </button>

        {/* Copyright - Center */}
        <div className="text-white text-[0.9rem] flex-1 text-center">
          {t("footer.copyright")}
        </div>

        {/* Empty div for spacing */}
        <div className="w-[3rem]"></div>
      </div>
    </div>
  );
};

export default Footer;
